import { GenericTeaser } from "@cinch-nx/landing-ui-shared";
import { StatsSection } from "@cinch-nx/landing-ui-shared";
import { TrustPilotQuote } from "@cinch-nx/landing-ui-shared";
import { Careers, Constellation, DeliverySection, ImageGallery, Partnerships } from "../components";
export const storyblokComponents = {
    GenericTeaser: GenericTeaser,
    StatsSection: StatsSection,
    GenericQuote: TrustPilotQuote,
    AboutUsCareers: Careers,
    AboutUsConstellation: Constellation,
    AboutUsDeliverySection: DeliverySection,
    AboutUsImageGallery: ImageGallery,
    AboutUsPartnershipSection: Partnerships
};
